import Flickity from "../../node_modules/flickity-fade";

document.addEventListener("alpine:init", () => {
    Alpine.data("testimonialSlider", () => ({
        slider: null,
        sliderContainer: null,
        sliderOptions: {},
        selectedIndex: 0,
        sliderEnd: false,
        isLoading: false,
        isLoading: false,
        init() {
            this.sliderContainer = this.$refs.slider;
            const slides = this.sliderContainer.querySelectorAll(".slide");

            let options = {
                cellAlign: "left",
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                groupCells: true,
                fade: true,
                on: {
                    ready: () => {
                        window.dispatchEvent(new Event("resize"));
                        this.sliderResize();
                    },
                    settle: () => {
                        this.updateTabIndexes(slides);
                        this.updateSliderEnd();
                    },
                    change: () => {
                        this.selectedIndex = this.slider.selectedIndex;
                        this.updateTabIndexes(slides);
                        this.updateSliderEnd();
                    },
                },
            };

            this.sliderOptions = options;

            this.slider = new Flickity(
                this.sliderContainer,
                this.sliderOptions
            );

            pegasus.onResizeFinished(() => {
                this.sliderResize();
            }, true);

            this.updateTabIndexes(slides);
        },
        sliderResize() {
            const flickitySliders = document.querySelectorAll(
                ".Testimonial__Slider-slider .flickity-slider"
            );

            this.sliderFullWidth = 0;

            flickitySliders.forEach((slider) => {
                const slides = slider.querySelectorAll(".slide");
                let height = 0;

                slides.forEach((slide) => {
                    slide.style.height = "";
                    this.sliderFullWidth += slide.offsetWidth;
                    if (slide.offsetHeight > height) {
                        height = slide.offsetHeight;
                    }
                });

                slides.forEach((slide) => {
                    slide.style.height = height + "px";
                });

                slider.style.height = "";
                slider.style.height = height + "px";
            });
        },
        updateSliderEnd() {
            const selectedIndex = this.slider.selectedIndex;
            const slideCount = this.slider.slides.length;
            this.sliderEnd = selectedIndex === slideCount - 1;
        },
        updateTabIndexes(slides) {
            slides.forEach((slide) => {
                const slideElements = slide.querySelectorAll("a, button");

                slideElements.forEach((element) => {
                    if (slide.classList.contains("is-selected")) {
                        element.removeAttribute("tabindex");
                    } else {
                        element.setAttribute("tabindex", "-1");
                    }
                });
            });
        },
    }));
});
